import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {navItemInterface} from "../../../../interfaces/featureInterface";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import ShopFeatureOptionsCommon from "../shopFeatureOptionsCommon";
import {usePrevious} from "../../../../misc/helperHooks";


const ShopCategoryListFeatureOptions = (props) => {

  const {navItem} = props;
  const feature = navItem.part;
  const prevFeature = usePrevious(feature);

  const [activeOption, setActiveOption] = useState(null);

  const {shopContextState, shopContextDispatch} = useShopContext();

  const {shopNavItems} = shopContextState;

  const optionsButtonClick = (option) => {

    const featureLabel = Analytics.getSkuForAnalytics(option.feature);
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopFeaturesListOptions + featureLabel);

    setActiveOption(option);
    const newNavItems = shopNavItems.map(navItem => {
      if (navItem.part.dbFeature.id === feature.dbFeature.id) {
        return {part: option.feature}
      }
      return navItem
    })
    shopContextDispatch(shopContextAction({shopNavItems: newNavItems}))
  };

  useEffect(() => {
    if (prevFeature && feature && (prevFeature.partId !== feature.partId)) {
      setActiveOption(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feature.partId])

  return (
    <ShopFeatureOptionsCommon feature={feature}
                              navItemOptions={navItem.colorOptions}
                              optionsButtonClick={optionsButtonClick}
                              activeOption={activeOption}/>
  )
};

ShopCategoryListFeatureOptions.propTypes = {
  navItem: PropTypes.shape(navItemInterface).isRequired,
}

export default ShopCategoryListFeatureOptions
